import Question from './Question';

export default Question;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/components/Question/index.js